"use strict";

var __extends = undefined && undefined.__extends || function () {
    var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(exports, "__esModule", { value: true });
var shortid = require('shortid');
var ConventionServitudeVueModel = /** @class */function () {
    function ConventionServitudeVueModel() {}
    return ConventionServitudeVueModel;
}();
exports.ConventionServitudeVueModel = ConventionServitudeVueModel;
var ConventionServitude = /** @class */function () {
    function ConventionServitude() {}
    return ConventionServitude;
}();
exports.ConventionServitude = ConventionServitude;
var DimensionsMassif = /** @class */function () {
    function DimensionsMassif() {}
    return DimensionsMassif;
}();
exports.DimensionsMassif = DimensionsMassif;
var Commune = /** @class */function () {
    function Commune() {}
    return Commune;
}();
exports.Commune = Commune;
var Acteur = /** @class */function () {
    function Acteur() {}
    return Acteur;
}();
exports.Acteur = Acteur;
var Proprietaire = /** @class */function (_super) {
    __extends(Proprietaire, _super);
    function Proprietaire() {
        var _this = _super.call(this) || this;
        _this.Identifier = shortid.generate();
        return _this;
    }
    return Proprietaire;
}(Acteur);
exports.Proprietaire = Proprietaire;
var Parcelle = /** @class */function () {
    function Parcelle(commune) {
        this.NonCadastree = false;
        this.Introuvable = false;
        this.DomainePublic = false;
        this.Proprietaires = [];
        this.CCODEP = commune.CCODEP;
        this.CCODIR = commune.CCODIR;
        this.CCOCOM = commune.CCOCOM;
        this.Identifier = shortid.generate();
    }
    return Parcelle;
}();
exports.Parcelle = Parcelle;
var GeneratedConvention = /** @class */function () {
    function GeneratedConvention() {}
    return GeneratedConvention;
}();
exports.GeneratedConvention = GeneratedConvention;


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/ConventionServitude/Models/index.ts
// module id = 229
// module chunks = 0